import dayjs from 'dayjs'
import { convertPaisaToRupee } from 'state/billing/billing.helpers'
import {
  BRAND_FILTER_TYPE,
  IBrandReportSummary,
  IBrandSaleSummary,
  IBrandSummaryDateFilter
} from 'state/new-summary/brand/brand.types'

export const getFormattedBrandSummary = (brandSummary: IBrandSaleSummary[]) => {
  if (brandSummary.length === 0) {
    return []
  }
  return brandSummary.map((item) => ({
    ...item,
    sale_amount: convertPaisaToRupee(Number(item.sale_amount || 0))
  }))
}

export const getOverallBrandSaleSummary = (brandSaleSummary: IBrandSaleSummary[]) => {
  if (brandSaleSummary.length === 0) {
    return {
      distributor_id: 'All Sales',
      sale_amount: 0,
      sale_quantity: 0,
      invoice_count: 0
    }
  }
  const result = brandSaleSummary.reduce(
    (acc, curr) => {
      return {
        distributor_id: 'All Sales',
        sale_amount: acc.sale_amount + curr.sale_amount,
        sale_quantity: acc.sale_quantity + curr.sale_quantity,
        invoice_count: acc.invoice_count + curr.invoice_count
      }
    },
    {
      distributor_id: 'All Sales',
      sale_amount: 0,
      sale_quantity: 0,
      invoice_count: 0
    }
  )
  return result
}

export const getFormattedBrandReportSummary = (brandReportSummary: IBrandReportSummary[]) => {
  return brandReportSummary.map((item) => ({
    ...item,
    net_amount: convertPaisaToRupee(Number(item.net_amount || 0)),
    gross_amount: convertPaisaToRupee(Number(item.gross_amount || 0)),
    tax_amount: convertPaisaToRupee(Number(item.tax_amount || 0))
  }))
}

const keyMapper: { [key in keyof IBrandReportSummary]?: string } = {
  product_description: 'Item Name',
  product_code: 'Product Code',
  customer_name: 'Customer Name',
  distributor_code: 'Distributor Code',
  distributor_name: 'Distributor Name',
  invoice_number: 'Invoice Number',
  invoice_date: 'Invoice Date',
  quantity: 'Quantity',
  sales_voucher_type: 'Sales Type',
  tax_amount: 'Tax Amount',
  gross_amount: 'Gross Amount',
  net_amount: 'Sale Value',
  region: 'Region',
  branch: 'Branch'
}

export const formatDataForExcel = (data: IBrandReportSummary[]) => {
  return data.map((obj) => {
    return Object.keys(keyMapper).reduce((acc: { [key: string]: any }, mappedKey) => {
      const originalKey = mappedKey as keyof IBrandReportSummary
      if (obj[originalKey] !== undefined) {
        // Use the mapped key for the output, in the order of keyMapper
        const newKey = keyMapper[originalKey] || originalKey // Mapped key or original key
        acc[newKey] = obj[originalKey]
      }
      return acc
    }, {})
  })
}

export const getExcelHeading = (activeFilter: IBrandSummaryDateFilter, title: string) => {
  const { startTime, endTime, filterType } = activeFilter
  return `${title} - ${
    filterType === BRAND_FILTER_TYPE.CUSTOM
      ? `${dayjs(startTime).format('DD MMM, YYYY')} - ${dayjs(endTime).format('DD MMM, YYYY')}`
      : filterType
  }`
}
